import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
}

const KeyholeShieldOutline = createIcon({
  displayName: 'KeyholeShieldOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path d="M0,0h24v24h-24v-24Z"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M20,11.242c0,4.368 -3.157,8.462 -7.48,9.686c-0.338,0.096 -0.702,0.096 -1.04,0c-4.323,-1.223 -7.48,-5.318 -7.48,-9.686v-4.028c0,-0.812 0.491,-1.544 1.243,-1.851l4.864,-1.99c1.214,-0.497 2.574,-0.497 3.787,0l4.864,1.99c0.751,0.307 1.242,1.039 1.242,1.851v4.028Z"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M13.538,11.925c0.436,-0.489 0.642,-1.186 0.447,-1.925c-0.181,-0.688 -0.745,-1.249 -1.433,-1.428c-1.375,-0.358 -2.611,0.67 -2.611,1.987c0,0.525 0.197,1.003 0.52,1.366c0.232,0.26 0.326,0.613 0.231,0.948l-0.386,1.353c-0.183,0.639 0.297,1.275 0.962,1.275h1.466c0.664,0 1.144,-0.636 0.962,-1.275l-0.386,-1.353c-0.098,-0.335 -0.003,-0.688 0.228,-0.948Z"
        ></path>
      </g>
    </>
  ),
})

const KeyholeShieldFilled = createIcon({
  displayName: 'KeyholeShieldFilled',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path d="M0,0h24v24h-24v-24Z"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M20,11.242c0,4.368 -3.157,8.462 -7.48,9.686c-0.338,0.096 -0.702,0.096 -1.04,0c-4.323,-1.223 -7.48,-5.318 -7.48,-9.686v-4.028c0,-0.812 0.491,-1.544 1.243,-1.851l4.864,-1.99c1.214,-0.497 2.574,-0.497 3.787,0l4.864,1.99c0.751,0.307 1.242,1.039 1.242,1.851v4.028Z"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M13.538,11.925c0.436,-0.489 0.642,-1.186 0.447,-1.925c-0.181,-0.688 -0.745,-1.249 -1.433,-1.428c-1.375,-0.358 -2.611,0.67 -2.611,1.987c0,0.525 0.197,1.003 0.52,1.366c0.232,0.26 0.326,0.613 0.231,0.948l-0.386,1.353c-0.183,0.639 0.297,1.275 0.962,1.275h1.466c0.664,0 1.144,-0.636 0.962,-1.275l-0.386,-1.353c-0.098,-0.335 -0.003,-0.688 0.228,-0.948Z"
        ></path>
      </g>
    </>
  ),
})

const KeyholeShield: FC<CustomIconProps> = (props) => {
  if (props.variant === 'filled') {
    return <CustomIcon as={KeyholeShieldFilled} {...props} />
  }
  return <CustomIcon as={KeyholeShieldOutline} {...props} />
}

export default memo(KeyholeShield)
